import {
  NonFinancialDriverNodeList,
  NonFinancialDriverValues
} from '@futrli/predict/core/api/types/non-financial-drivers';
import { flattenTree } from '@futrli/shared-services';
import { buildDriverTree, DriverTreeNode } from './driversTree';

export const getGroups = (driversOrder: NonFinancialDriverNodeList[], driversData: NonFinancialDriverValues[] = []) => {
  return getGroupsFromTree(buildDriverTree(driversOrder, driversData).tree);
};

export const getGroupsFromTree = (driversTree: DriverTreeNode[]) => {
  return flattenTree(driversTree).filter(node => node.isGroup);
};
